(function () {
  if (typeof window === "undefined") return;

  const UTM_KEYS = ["utm_source", "utm_medium", "utm_campaign"];

  const getSearchParams = (search) => new URLSearchParams(search);

  const getSavedUtms = () => {
    try {
      const data = sessionStorage.getItem("utm_params");
      return data ? JSON.parse(data) : {};
    } catch (e) {
      console.warn("[utmKeeper] Failed to access sessionStorage:", e);
      return {};
    }
  };
  const saveUtms = (utms) => {
    try {
      sessionStorage.setItem("utm_params", JSON.stringify(utms));
    } catch (e) {
      console.warn("[utmKeeper] Failed to save to sessionStorage:", e);
    }
  };

  const currentParams = getSearchParams(window.location.search);
  let hasNewUtm = false;
  const newUtmData = {};

  UTM_KEYS.forEach((key) => {
    const val = currentParams.get(key);
    if (val) {
      newUtmData[key] = val;
      hasNewUtm = true;
    }
  });

  if (hasNewUtm) {
    saveUtms(newUtmData);
  }

  const appendUtmsToUrl = (url) => {
    if (!url) return url;
    try {
      const targetUrl = new URL(url, window.location.origin);
      if (targetUrl.origin !== window.location.origin) {
        return url;
      }

      const targetParams = targetUrl.searchParams;
      const savedUtms = getSavedUtms();
      let targetHasUtm = false;
      const targetUtmData = {};
      UTM_KEYS.forEach((key) => {
        const val = targetParams.get(key);
        if (val) {
          targetUtmData[key] = val;
          targetHasUtm = true;
        }
      });

      if (targetHasUtm) {
        saveUtms(targetUtmData);
      } else {
        let modified = false;
        Object.keys(savedUtms).forEach((key) => {
          if (!targetParams.has(key)) {
            targetParams.set(key, savedUtms[key]);
            modified = true;
          }
        });
      }
      const isRelative =
        !url.startsWith("http://") &&
        !url.startsWith("https://") &&
        !url.startsWith("//");
      if (isRelative) {
        return targetUrl.pathname + targetUrl.search + targetUrl.hash;
      }
      return targetUrl.toString();
    } catch (e) {
      console.error("[utmKeeper] Error appending UTMs:", e);
      return url;
    }
  };

  // 2. Intercept History API (pushState & replaceState)
  const originalPushState = window.history.pushState;
  const originalReplaceState = window.history.replaceState;

  window.history.pushState = function (state, title, url) {
    const modifiedUrl = appendUtmsToUrl(url);
    return originalPushState.apply(this, [state, title, modifiedUrl]);
  };

  window.history.replaceState = function (state, title, url) {
    const modifiedUrl = appendUtmsToUrl(url);
    return originalReplaceState.apply(this, [state, title, modifiedUrl]);
  };

  const savedUtms = getSavedUtms();
  let initialUrlNeedsModification = false;

  Object.keys(savedUtms).forEach((key) => {
    if (!currentParams.has(key)) {
      currentParams.set(key, savedUtms[key]);
      initialUrlNeedsModification = true;
    }
  });

  if (initialUrlNeedsModification) {
    const newSearch = currentParams.toString();
    const newUrl =
      window.location.pathname + "?" + newSearch + window.location.hash;
    originalReplaceState.apply(window.history, [
      window.history.state,
      "",
      newUrl,
    ]);
  }
})();